
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 136.12 69.43"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M62.19 67.41a5.47 5.47 0 1110.93 0M109.27 67.93h-3a38.34 38.34 0 00-76.67 0h-3a41.34 41.34 0 0182.67 0z"}}),_c('path',{staticClass:"a",attrs:{"d":"M124.26 67.93h-3a53.33 53.33 0 00-106.65 0h-3a56.33 56.33 0 01112.65 0z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"53.1","cy":"31.06","r":"4.92"}}),_c('path',{staticClass:"a",attrs:{"d":"M67.93 69.39a1.5 1.5 0 01-1.5-1.5V1.5a1.5 1.5 0 013 0v66.39a1.5 1.5 0 01-1.5 1.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M134.37 69.43H1.5a1.5 1.5 0 010-3h132.87a1.5 1.5 0 010 3z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"17.41","cy":"47.24","r":"7.78"}}),_c('path',{staticClass:"a",attrs:{"d":"M110.13 10.62c19.34 7.08 25.37 32.67 25.49 37.28l-67.4 19.3.16-.08 41.71-56.49"}}),_c('path',{staticClass:"a",attrs:{"d":"M68.22 67.7a.5.5 0 01-.47-.32.51.51 0 01.24-.63h.06l41.64-56.39a.48.48 0 01.27-.18.5.5 0 01.34 0C129.12 17 136 41.84 136.12 47.89a.54.54 0 01-.37.51l-67.4 19.28zm42.07-56.49L69.62 66.28l65.47-18.73c-.4-4.63-6.09-29.22-24.8-36.34zm25.33 36.71z"}}),_c('path',{staticClass:"a",attrs:{"d":"M97.22 67.93h-3a26.29 26.29 0 00-52.57 0h-3a29.29 29.29 0 0158.57 0z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"44.35","cy":"54.17","r":"4.35"}})])
          )
        }
      }
    